<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <section class="white">
    <div class="content-wrapper pos-rel-md">
      <app-page-retrieval-error
        *ngIf="faqRetrievalError"
      ></app-page-retrieval-error>
      <h1 *ngIf="!faqRetrievalError">FAQs</h1>
      <div
        class="small-content-wrapper margin-center"
        *ngIf="!faqRetrievalError"
      >
        <h2>
          <app-render-markdown [content]="theFAQ.title"></app-render-markdown>
        </h2>
        <div>
          <app-render-markdown [content]="theFAQ.answer"></app-render-markdown>
        </div>
      </div>
    </div>
  </section>
</div>
